import UIFileAttachment from 'UIComponents/attachment/UIFileAttachment';
import styled from 'styled-components';
const StyledUIFileAttachment = styled(UIFileAttachment).withConfig({
  displayName: "StyledUIFileAttachment",
  componentId: "sc-11htnp-0"
})(["margin-top:4px;background-color:transparent;border:none;padding:8px 12px;"]);
export default StyledUIFileAttachment;